export default __webpack_public_path__ + "static/media/filstats02.10d00083.png";